// Polyfills and Error Handlers
// This file contains fixes for common browser compatibility issues and Vue internal errors

// Polyfill for Array.prototype.at() to support older browsers
export function setupPolyfills() {
  if (!Array.prototype.at) {
    Array.prototype.at = function(n) {
      // ToInteger() abstract op
      n = Math.trunc(n) || 0;
      // Allow negative indexing from the end
      if (n < 0) n += this.length;
      // OOB access is guaranteed to return undefined
      if (n < 0 || n >= this.length) return undefined;
      // Otherwise, this is just normal property access
      return this[n];
    };
  }
}

// Global error handler to suppress Vue internal DOM errors
export function setupErrorHandlers(app) {
  // Note: Error filtering is now handled in Sentry configuration (sentry.ts)
  // This function is kept for potential future use but currently does nothing
}
